import * as React from "react"
import * as ReactDOM from "react-dom"
import 'react-dates/initialize';
import { DateRangePicker, DateRangePickerShape, FocusedInputShape, OrientationShape } from 'react-dates';
import * as moment_base from 'moment';
import { Moment } from 'moment';
import { extendMoment, DateRange } from 'moment-range';
import * as Immutable from 'immutable'

import 'react-dates/lib/css/_datepicker.css';

declare var I18n: any

const moment = extendMoment(moment_base);
const now = Date.now()

export type NullableMoment = Moment | null;
export type StartEnd = { startDate: NullableMoment, endDate: NullableMoment }

const blockedTypes = Immutable.Set<string>(["unavailable", "reserved", "booked"])

export type DisabledProps = { disabled: boolean }
export type PrefixProps = { prefix?: string }

type Props = StartEnd & PrefixProps & DisabledProps & {
  renderDay: (day: Moment) => (string | JSX.Element),
  onDatesChange: (arg: { startDate: Moment | null, endDate: Moment | null }) => void,
  isDayBlocked: (day: Moment) => boolean,
  isOutsideRange: (day: Moment) => boolean,
  onFocusChange: (fi: FocusedInputShape) => void,
  focusedInput: FocusedInputShape
  showClearDate?: boolean
  orientation?: OrientationShape
  numberOfMonths?: number
  renderCalenderInfo?:(_:DateRange) => JSX.Element,
  startDatePlaceholderText?: string
  endDatePlaceholderText?: string
}

type State = {
  startDateId: string,
  endDateId: string,
  screenSize: 'mobile' | 'desktop' | 'loading',
  focusedInput: FocusedInputShape,
  currentMonth: Moment,
}

declare var $:any

export default class PeriodPicker extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
    this.state = {
      startDateId: this.props.prefix ? this.props.prefix + '_start_date' : 'start_date',
      endDateId:   this.props.prefix ? this.props.prefix + '_end_date'   : 'end_date',
      focusedInput: null,
      screenSize: 'loading',
      currentMonth: moment(this.props.startDate).startOf('M'),
    }
  }

  componentDidMount() {
    this.onResize = this.onResize.bind(this)
    window.addEventListener('resize', this.onResize)
    this.onResize();
  }

  onResize() {
    if ($(window).outerWidth() <= 768) {
      this.setState({screenSize : 'mobile'})
    } else {
      this.setState({screenSize : 'desktop'})
    }
  }

  componentDidUpdate() {
    if (null !== this.props.focusedInput && this.state.screenSize === 'mobile') {
      $('body').addClass('overflow--hidden')
    } else {
      $('body').removeClass('overflow--hidden')
    }
  }

  onVisibleMonthChange(e: React.EventHandler<React.MouseEvent<HTMLSpanElement>>) {
    this.setState({ ...this.state, currentMonth: moment(e) })
  }


  getVisibleMonthsRange() : DateRange {
    return moment.range(
      this.state.currentMonth.clone().startOf('M'),
      this.state.currentMonth.clone().add(this.getNumberOfMonths() - 1, 'M').endOf('M')
    )
  }

  getNumberOfMonths() : number {
    return  this.props.numberOfMonths == undefined ?
      (this.state.screenSize == 'mobile' ? 1 : 2)
      : this.props.numberOfMonths
  }

  render() {
    const orientation : OrientationShape = this.props.orientation == undefined ?
      (this.state.screenSize == 'mobile' ? 'vertical' : 'horizontal')
      : this.props.orientation

    const shape: DateRangePickerShape = {
      startDatePlaceholderText: this.props.startDatePlaceholderText == undefined ?
        I18n.t("rental_adverts.placeholders.start_date") :
        this.props.startDatePlaceholderText,
      endDatePlaceholderText: this.props.endDatePlaceholderText == undefined ?
        I18n.t("rental_adverts.placeholders.end_date") :
        this.props.endDatePlaceholderText,
      startDateId: this.state.startDateId,
      endDateId: this.state.endDateId,
      startDate: this.props.startDate,
      endDate:   this.props.endDate,
      focusedInput: this.props.focusedInput,
      onDatesChange:  (arg: StartEnd) => this.props.onDatesChange(arg),
      onFocusChange:  (arg: FocusedInputShape) => this.props.onFocusChange(arg),
      isDayBlocked:   (day: Moment) => this.props.isDayBlocked(day),
      isOutsideRange: (day: Moment) => this.props.isOutsideRange(day),
      renderDay: (day: Moment) => this.props.renderDay(day),
      firstDayOfWeek: 1,
      minimumNights: 0,
      showClearDates: this.props.showClearDate === undefined ? true : this.props.showClearDate,
      displayFormat: 'DD-MM-YYYY',
      numberOfMonths: this.state.screenSize == 'mobile' ? this.getNumberOfMonths() - 1 : this.getNumberOfMonths(),
      hideKeyboardShortcutsPanel: true,
      disabled: this.props.disabled,
      withFullScreenPortal: this.state.screenSize == 'mobile',
      orientation: orientation,
      renderCalendarInfo: () => this.props.renderCalenderInfo ? this.props.renderCalenderInfo(this.getVisibleMonthsRange()) : '',
      onNextMonthClick: (e) => this.onVisibleMonthChange(e),
      onPrevMonthClick: (e) => this.onVisibleMonthChange(e),
    }

    return (
      <div>
        <DateRangePicker {...shape} />
      </div>
    )
  }
}
